<template>
  <div>
    <b-row class="m-0 pt-3 mt-5 justify-content-center">
      
    </b-row>
    <b-row class="m-0 mt-5 justify-content-center">
      <div>
        <b-row class="m-0">
          <h1 class="m-0 mt-2">mein</h1>
          <div>
            <b-img-lazy :src="require(`@/assets/logos/eatDoradoText.png`)" class="ml-2 mt-2" style=" max-width: 90%; width: 240px; height: 42px" fluid alt="eatDorado Logo"></b-img-lazy>  
          </div>
        </b-row>
      </div>
    
    </b-row>
    <b-row class="m-0 mt-5 justify-content-center">
      <div style="width: 600px; max-width: 100%" class="mx-3">
        <h4 v-if="userInformations" class="text-center">Hallo, {{ userInformations.firstname }}!</h4>
      </div>
    </b-row>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/Footer'
import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'Profil',
  mixins: [coreData],
  data: () => {
    return {
      form: {},
    }
  },
  components: {
    Footer
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    },
    contactFormSent(){
      return this.$store.getters.contactFormSent
    }
  },
  watch:{
    contactFormSent(){
      if(this.contactFormSent){
        this.form = {}
      }
    }
  },
  mounted() {
  },
  methods: {
    // submitForm(){
    //   this.$store.dispatch('sendContactForm', this.form)
    // } 
  }
}
</script>